import React, { useState, useRef, useEffect } from "react";

const ChatWidget: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState<{ sender: "user" | "bot"; text: string }[]>([]);
  const [input, setInput] = useState("");
  const chatMessagesRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (chatMessagesRef.current) {
      chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight;
    }
  }, [messages]);

  const toggleChat = () => {
    setIsOpen(!isOpen);
    if (!isOpen && messages.length === 0) {
      addBotMessage("Hi there 👋! How can I help you today?");
    }
  };

  const addUserMessage = (text: string) => {
    setMessages((prev) => [...prev, { sender: "user", text }]);
  };

  const addBotMessage = (text: string) => {
    setMessages((prev) => [...prev, { sender: "bot", text }]);
  };

  const getBotReply = (input: string) => {
    const msg = input.toLowerCase();
    if (msg.includes("hello") || msg.includes("hi"))
      return "Hello! 👋 How can I assist you today?";
    if (msg.includes("job"))
      return "You can explore jobs in the 'Find Jobs' section at the top menu.";
    if (msg.includes("contact"))
      return "You can reach us through the Contact section below.";
    if (msg.includes("help"))
      return "Sure! I can guide you — tell me what you’re looking for.";
    return "Thank you for your message! Our support team will get back to you soon.";
  };

  const sendMessage = () => {
    const msg = input.trim();
    if (!msg) return;
    addUserMessage(msg);
    setInput("");
    setTimeout(() => {
      addBotMessage(getBotReply(msg));
    }, 600);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") sendMessage();
  };

  return (
    <div id="chat-widget">
      {/* Chat Button */}
      {!isOpen && (
        <button id="chat-button" onClick={toggleChat}>
          <i className="bi bi-chat-dots-fill"></i>
        </button>
      )}

      {/* Chat Box */}
      {isOpen && (
        <div id="chat-box" className="shadow" style={{ display: "flex", flexDirection: "column" }}>
          <div id="chat-header">
            <strong>SailorsData Support</strong>
            <button id="close-chat" onClick={toggleChat}>
              &times;
            </button>
          </div>

          <div id="chat-messages" ref={chatMessagesRef}>
            {messages.map((m, i) => (
              <p key={i} className={m.sender}>
                {m.text}
              </p>
            ))}
          </div>

          <div id="chat-input-area">
            <input
              type="text"
              id="chat-input"
              placeholder="Type a message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyPress}
            />
            <button id="send-message" onClick={sendMessage}>
              <i className="bi bi-send-fill"></i>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatWidget;
